<script lang="ts">
  import type { IntegrationDetails, IntegrationFlow } from "../../helpers/types";
  import { postIntegrationFlow } from "../../helpers/integrations-api";

  export let integration: IntegrationDetails;

  $: creditNoteFlow = integration.flows.find((f) => f.name == "credit_note");

  function postCreditNoteFlow(event: Event & { currentTarget: EventTarget & HTMLInputElement }) {
    postIntegrationFlow(integration.id, "credit_note", event.currentTarget.checked).then((res) => {
      console.log(res);
    });
  }
</script>

<div class="container">
  <div class="header">
    <label class="switch">
      <input
        id="crn-flow"
        type="checkbox"
        checked={creditNoteFlow?.enabled}
        on:change={(e) => postCreditNoteFlow(e)}
      />
      <span class="slider round" />
    </label>
    <label class="subtitle" for="crn-flow">credit note</label>
  </div>
</div>

<style>
  .container {
    border-radius: 8px;
    background-color: white;
    margin-bottom: 18px;
  }

  .header {
    display: flex;
    padding: 18px;
    border-bottom: 1px solid;
    border-color: var(--rekki-neutral-01);
    align-items: center;
  }

  .subtitle {
    font-size: 18px;
    font-weight: bold;
    margin-left: 12px;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #016943;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #016943;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
</style>
